import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const AddProductTypesSlice = createSlice({
    name: "addProductType",
    initialState,
    reducers: {
        addProductTypeRequest(state) {
            state.loading = true;
        },
        addProductTypeRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        addProductTypeRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        addProductTypeStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    addProductTypeRequest,
    addProductTypeRequestSuccess,
    addProductTypeRequestError,
    addProductTypeStateReset
} = AddProductTypesSlice.actions;

export default AddProductTypesSlice.reducer;
